module.exports = __webpack_public_path__ + "img/main_logo_back.6717658d.png";